@if (isVisible$ | async) {
    <div class="app-rating-banner" [@slideAnimation] role="region" aria-label="App vurdering banner">
        <div class="app-rating-banner__container">
            <div class="app-rating-banner__content">
                <h2 class="app-rating-banner__title">Har du lyst til at vurdere E|Forsyning?</h2>
                <p class="app-rating-banner__subtitle">Det hjælper os med at forbedre oplevelsen.</p>
            </div>
            <div class="app-rating-banner__actions">
                <button class="app-rating-banner__button app-rating-banner__button--yes" (click)="onYes()" type="button">Ja</button>
                <button class="app-rating-banner__button" (click)="onNo()" type="button">Nej</button>
                <button class="app-rating-banner__button app-rating-banner__button--link" (click)="onDontShowAgain()" type="button">Vis ikke igen</button>
            </div>
        </div>
    </div>
}
